//@flow
import React, { useRef, useState, useCallback } from "react";

//  $FlowFixMe
import css from "./durationbar.module.scss";

type Props = {
  completePercent: number,
  isLiveStream: boolean,
  isPlaying: boolean,
};
const DurationBar = (props: Props): Object => {
  const completePC = props.completePercent;
  const barref = useRef(null);
  const [leftPos, setLeftPos] = useState(0);
  const leftPosValue = useRef(0);
  const requestRef = useRef();
  // const prevLeftPos = useRef(0);

  const animate = useCallback(() => {
    leftPosValue.current = (leftPosValue.current + 1) % 100;
    setLeftPos(leftPosValue.current);
    requestRef.current = requestAnimationFrame(animate);
  },[]);
  // const animate = () => {
  //   leftPosValue.current = (leftPosValue.current + 1) % 100;
  //   setLeftPos(leftPosValue.current);
  //   requestRef.current = requestAnimationFrame(animate);
  // };

  React.useEffect(() => {
    requestRef.current = requestAnimationFrame(animate);
    // $FlowIgnore
    return () => cancelAnimationFrame(requestRef.current);
  }, [animate]); // Make sure the effect runs only once

  const cBar = (
    // props.isLiveStream && props.isPlaying ? (
    // is live stream
    // run animation
    <div ref={barref} className={[css.durationBarComplete].join(" ")} />
  );
  // ) : (
  //   <div
  //     className={css.durationBarComplete}
  //     style={{
  //       width: completePC && completePC + "vw",
  //     }}
  //   />
  // );
  if (barref.current) {
    if (props.isLiveStream && props.isPlaying) {
      // $FlowIgnore
      barref.current.style.width = `${10 + Math.sinh(leftPos / 100) * 20}vw`;
      // $FlowIgnore
      barref.current.style.left = `${leftPos}vw`;
    } else {
      barref.current.style.width = `${completePC}vw`;
      barref.current.style.left = `0vw`;
    }
  }
  return (
    <div className={css.wrapper}>
      <div className={css.durationBar}>{cBar}</div>
    </div>
  );
};

export default DurationBar;
